import { render, staticRenderFns } from "./CompleteTaskModal.vue?vue&type=template&id=8d9ec1a0&scoped=true&class=fill-height&"
import script from "./CompleteTaskModal.vue?vue&type=script&lang=ts&"
export * from "./CompleteTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteTaskModal.vue?vue&type=style&index=0&id=8d9ec1a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9ec1a0",
  null
  
)

export default component.exports